import {NavDropdown} from './components/NavDropdown/NavDropdown'
import {NavLink} from './components/NavLink/NavLink'

import {UrlProvider} from './contexts/UrlContext'

import DATA from './MarketingNavigation.data'
import styles from './MarketingNavigation.module.css'

type Props = {
  should_use_dotcom_links?: boolean
}

export function MarketingNavigation(props: Props) {
  const {should_use_dotcom_links: shouldUseDotcomLinks = false} = props

  return (
    <UrlProvider shouldUseDotcomLinks={shouldUseDotcomLinks}>
      <nav className={styles.nav} aria-label="Global">
        <ul className={styles.list}>
          {DATA.map(item => (
            <li key={item.title}>
              {'groups' in item ? (
                <NavDropdown {...item} />
              ) : (
                <NavLink {...item} context={item.title} className={styles.navLink} />
              )}
            </li>
          ))}
        </ul>
      </nav>
    </UrlProvider>
  )
}
